import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {catchError, NEVER, Observable, throwError} from "rxjs";
import {ErrorHandlerService} from "../service/error-handler.service";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {AuthStore, authStore} from "../service/auth/auth.store";

export const ErrorHandlerInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<any>>  => {

        const errorHandlerService: ErrorHandlerService = inject(ErrorHandlerService);
        const router: Router = inject(Router);
        const auth: AuthStore = inject(authStore);

        if (isModification(request)) {
            errorHandlerService.clearErrors();
        }

        return next(request).pipe(

            catchError((response: HttpErrorResponse): Observable<never> => {

                if (!(response instanceof HttpErrorResponse)) {
                    return throwError(response);
                }

                if (response.status === 401) {

                    auth.setRedirectUrl(router.url);
                    auth.userLoggedOut();

                }

                errorHandlerService.handleError(response);

                return NEVER;
            })
        );



}

function isModification(request: HttpRequest<any>) {
    return ['POST', 'PUT'].includes(request.method.toUpperCase());
}